import BillingsOrderCargoTaxiCreateRequest, {
  BillingsOrderCargoTaxiCreateRequestBody,
} from "./billings-order-cargo-taxi-create.request";

const createBody = (
  request: BillingsOrderCargoTaxiCreateRequest,
): BillingsOrderCargoTaxiCreateRequestBody => {
  return {
    billingContributions: request.billingContributions,
    billingNodes: request.billingNodes,
  };
};

const billingsOrderCargoTaxiCreateRequestFactory = {
  createBody,
};

export default billingsOrderCargoTaxiCreateRequestFactory;
